export var SourceType;
(function (SourceType) {
    SourceType["UNDEFINED"] = "UNDEFINED";
    SourceType["APP"] = "APP";
})(SourceType || (SourceType = {}));
export var EmailInfoTag;
(function (EmailInfoTag) {
    EmailInfoTag["UNTAGGED"] = "UNTAGGED";
    EmailInfoTag["MAIN"] = "MAIN";
    EmailInfoTag["HOME"] = "HOME";
    EmailInfoTag["WORK"] = "WORK";
})(EmailInfoTag || (EmailInfoTag = {}));
export var PhoneInfoTag;
(function (PhoneInfoTag) {
    PhoneInfoTag["UNTAGGED"] = "UNTAGGED";
    PhoneInfoTag["MAIN"] = "MAIN";
    PhoneInfoTag["HOME"] = "HOME";
    PhoneInfoTag["MOBILE"] = "MOBILE";
    PhoneInfoTag["WORK"] = "WORK";
    PhoneInfoTag["FAX"] = "FAX";
})(PhoneInfoTag || (PhoneInfoTag = {}));
export var Tag;
(function (Tag) {
    Tag["UNTAGGED"] = "UNTAGGED";
    Tag["HOME"] = "HOME";
    Tag["WORK"] = "WORK";
    Tag["BILLING"] = "BILLING";
    Tag["SHIPPING"] = "SHIPPING";
})(Tag || (Tag = {}));
export var ContactField;
(function (ContactField) {
    ContactField["UNDEFINED"] = "UNDEFINED";
    ContactField["FIRST_NAME"] = "FIRST_NAME";
    ContactField["LAST_NAME"] = "LAST_NAME";
    ContactField["COMPANY"] = "COMPANY";
    ContactField["POSITION"] = "POSITION";
    ContactField["EMAIL"] = "EMAIL";
    ContactField["PHONE"] = "PHONE";
    ContactField["ADDRESS"] = "ADDRESS";
    ContactField["BIRTHDATE"] = "BIRTHDATE";
    ContactField["EXTENDED_FIELD"] = "EXTENDED_FIELD";
})(ContactField || (ContactField = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["UNDEFINED_DAY"] = "UNDEFINED_DAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
})(DayOfWeek || (DayOfWeek = {}));
/** Date range is inclusive */
export var AllowDateRange;
(function (AllowDateRange) {
    AllowDateRange["UNDEFINED_RANGE"] = "UNDEFINED_RANGE";
    AllowDateRange["FUTURE_ONLY"] = "FUTURE_ONLY";
    AllowDateRange["PAST_ONLY"] = "PAST_ONLY";
    AllowDateRange["PAST_AND_FUTURE"] = "PAST_AND_FUTURE";
})(AllowDateRange || (AllowDateRange = {}));
/**
 * The 'rel' attribute of the link. The rel attribute defines the relationship between a linked resource and the current document.
 * Further reading (also about different possible rel types): https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel
 * Following are the accepted 'rel' types by Wix applications.
 */
export var LinkRel;
(function (LinkRel) {
    /** default (not implemented) */
    LinkRel["unknown_link_rel"] = "unknown_link_rel";
    /** Indicates that the current document's original author or publisher does not endorse the referenced document. */
    LinkRel["nofollow"] = "nofollow";
    /** Instructs the browser to navigate to the target resource without granting the new browsing context access to the document that opened it. */
    LinkRel["noopener"] = "noopener";
    /** No Referer header will be included. Additionally, has the same effect as noopener. */
    LinkRel["noreferrer"] = "noreferrer";
    /** Indicates a link that resulted from advertisements or paid placements. */
    LinkRel["sponsored"] = "sponsored";
})(LinkRel || (LinkRel = {}));
export var AttachmentSettingsMediaType;
(function (AttachmentSettingsMediaType) {
    AttachmentSettingsMediaType["UNDEFINED"] = "UNDEFINED";
    AttachmentSettingsMediaType["IMAGE_AND_VIDEO"] = "IMAGE_AND_VIDEO";
    AttachmentSettingsMediaType["IMAGE"] = "IMAGE";
    AttachmentSettingsMediaType["VIDEO"] = "VIDEO";
    AttachmentSettingsMediaType["DOCUMENT"] = "DOCUMENT";
    AttachmentSettingsMediaType["AUDIO"] = "AUDIO";
})(AttachmentSettingsMediaType || (AttachmentSettingsMediaType = {}));
export var TimeFormat;
(function (TimeFormat) {
    TimeFormat["UNDEFINED_FORMAT"] = "UNDEFINED_FORMAT";
    TimeFormat["HOURS_12"] = "HOURS_12";
    TimeFormat["HOURS_24"] = "HOURS_24";
})(TimeFormat || (TimeFormat = {}));
export var TimePickerSettingsType;
(function (TimePickerSettingsType) {
    TimePickerSettingsType["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
    TimePickerSettingsType["DROPDOWN"] = "DROPDOWN";
    TimePickerSettingsType["STEPPER"] = "STEPPER";
    TimePickerSettingsType["TEXT"] = "TEXT";
})(TimePickerSettingsType || (TimePickerSettingsType = {}));
export var MediaType;
(function (MediaType) {
    MediaType["UNDEFINED"] = "UNDEFINED";
    MediaType["IMAGE_AND_VIDEO"] = "IMAGE_AND_VIDEO";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO"] = "VIDEO";
    MediaType["DOCUMENT"] = "DOCUMENT";
    MediaType["AUDIO"] = "AUDIO";
})(MediaType || (MediaType = {}));
export var FirstDayOfWeek;
(function (FirstDayOfWeek) {
    FirstDayOfWeek["UNDEFINED"] = "UNDEFINED";
    FirstDayOfWeek["SUNDAY"] = "SUNDAY";
    FirstDayOfWeek["MONDAY"] = "MONDAY";
    FirstDayOfWeek["TUESDAY"] = "TUESDAY";
    FirstDayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    FirstDayOfWeek["THURSDAY"] = "THURSDAY";
    FirstDayOfWeek["FRIDAY"] = "FRIDAY";
    FirstDayOfWeek["SATURDAY"] = "SATURDAY";
})(FirstDayOfWeek || (FirstDayOfWeek = {}));
export var FieldType;
(function (FieldType) {
    FieldType["UNDEFINED"] = "UNDEFINED";
    FieldType["TEXT"] = "TEXT";
    FieldType["PARAGRAPH"] = "PARAGRAPH";
    FieldType["CHECKBOX"] = "CHECKBOX";
    FieldType["DATE_PICKER"] = "DATE_PICKER";
    FieldType["DROP_DOWN"] = "DROP_DOWN";
    FieldType["RADIO_GROUP"] = "RADIO_GROUP";
    FieldType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    FieldType["NUMBER"] = "NUMBER";
    FieldType["EMAIL"] = "EMAIL";
    FieldType["PHONE"] = "PHONE";
    FieldType["URL"] = "URL";
    FieldType["SIGNATURE"] = "SIGNATURE";
    FieldType["RATING"] = "RATING";
    FieldType["MULTI_LINE_ADDRESS"] = "MULTI_LINE_ADDRESS";
    FieldType["PHONE_COUNTRY_CODE"] = "PHONE_COUNTRY_CODE";
    FieldType["AUTO_COMPLETE_ADDRESS"] = "AUTO_COMPLETE_ADDRESS";
    FieldType["ATTACHMENTS"] = "ATTACHMENTS";
    FieldType["TIME_PICKER"] = "TIME_PICKER";
    FieldType["HEADING"] = "HEADING";
    FieldType["TEXT_BLOCK"] = "TEXT_BLOCK";
    FieldType["SUBSCRIPTION_CHECKBOX"] = "SUBSCRIPTION_CHECKBOX";
})(FieldType || (FieldType = {}));
export var Type;
(function (Type) {
    Type["UNDEFINED"] = "UNDEFINED";
    Type["FIRST_NAME"] = "FIRST_NAME";
    Type["LAST_NAME"] = "LAST_NAME";
    Type["COMPANY"] = "COMPANY";
    Type["POSITION"] = "POSITION";
    Type["UNTAGGED_EMAIL"] = "UNTAGGED_EMAIL";
    Type["MAIN_EMAIL"] = "MAIN_EMAIL";
    Type["HOME_EMAIL"] = "HOME_EMAIL";
    Type["WORK_EMAIL"] = "WORK_EMAIL";
    Type["UNTAGGED_PHONE"] = "UNTAGGED_PHONE";
    Type["MAIN_PHONE"] = "MAIN_PHONE";
    Type["HOME_PHONE"] = "HOME_PHONE";
    Type["WORK_PHONE"] = "WORK_PHONE";
    Type["MOBILE_PHONE"] = "MOBILE_PHONE";
    Type["FAX"] = "FAX";
    Type["UNTAGGED_ADDRESS"] = "UNTAGGED_ADDRESS";
    Type["HOME_ADDRESS"] = "HOME_ADDRESS";
    Type["WORK_ADDRESS"] = "WORK_ADDRESS";
    Type["BILLING_ADDRESS"] = "BILLING_ADDRESS";
    Type["SHIPPING_ADDRESS"] = "SHIPPING_ADDRESS";
    Type["BIRTHDATE"] = "BIRTHDATE";
    Type["EXTENDED_FIELD"] = "EXTENDED_FIELD";
})(Type || (Type = {}));
export var PublishedStatus;
(function (PublishedStatus) {
    PublishedStatus["UNDEFINED"] = "UNDEFINED";
    /** Form is published and available on the site. */
    PublishedStatus["PUBLISHED"] = "PUBLISHED";
    /** Form was published but removed from the site. */
    PublishedStatus["DELETED"] = "DELETED";
    /** Form was created in the editor, but was not yet published. */
    PublishedStatus["DRAFT"] = "DRAFT";
    /** Form was created in the editor, but deleted before the site was published. */
    PublishedStatus["DISCARDED"] = "DISCARDED";
    /** Form marked as archived */
    PublishedStatus["ARCHIVED"] = "ARCHIVED";
})(PublishedStatus || (PublishedStatus = {}));
export var SubscriptionMode;
(function (SubscriptionMode) {
    SubscriptionMode["UNDEFINED"] = "UNDEFINED";
    /** User is added to the subscription list directly after filling out the form */
    SubscriptionMode["ON_SUBMIT"] = "ON_SUBMIT";
    /** User is added to the subscription list after they verify their mail address */
    SubscriptionMode["AFTER_CONFIRMATION"] = "AFTER_CONFIRMATION";
})(SubscriptionMode || (SubscriptionMode = {}));
export var TimeFrame;
(function (TimeFrame) {
    TimeFrame["UNDEFINED"] = "UNDEFINED";
    TimeFrame["HOURLY"] = "HOURLY";
    TimeFrame["DAILY"] = "DAILY";
    TimeFrame["WEEKLY"] = "WEEKLY";
    TimeFrame["MONTHLY"] = "MONTHLY";
    TimeFrame["YEARLY"] = "YEARLY";
    /** No time restriction */
    TimeFrame["TOTAL"] = "TOTAL";
})(TimeFrame || (TimeFrame = {}));
export var DateOperator;
(function (DateOperator) {
    DateOperator["UNDEFINED"] = "UNDEFINED";
    /** Submissions can be done before the specified date */
    DateOperator["BEFORE"] = "BEFORE";
})(DateOperator || (DateOperator = {}));
export var FormType;
(function (FormType) {
    FormType["UNDEFINED"] = "UNDEFINED";
    FormType["SUBSCRIPTION"] = "SUBSCRIPTION";
    FormType["REGISTRATION"] = "REGISTRATION";
    FormType["PAYMENT"] = "PAYMENT";
    FormType["CAPTCHA"] = "CAPTCHA";
    FormType["MULTI_STEP"] = "MULTI_STEP";
    FormType["NO_INBOX_NOTIFICATION"] = "NO_INBOX_NOTIFICATION";
    FormType["LIMITS"] = "LIMITS";
    FormType["APP"] = "APP";
})(FormType || (FormType = {}));
export var Operation;
(function (Operation) {
    Operation["UNDEFINED"] = "UNDEFINED";
    Operation["SHOW"] = "SHOW";
    Operation["HIDE"] = "HIDE";
    Operation["REQUIRED"] = "REQUIRED";
    Operation["OPTIONAL"] = "OPTIONAL";
})(Operation || (Operation = {}));
export var FormDirection;
(function (FormDirection) {
    FormDirection["UNDEFINED"] = "UNDEFINED";
    FormDirection["LTR"] = "LTR";
    FormDirection["RTL"] = "RTL";
})(FormDirection || (FormDirection = {}));
export var FormExposure;
(function (FormExposure) {
    FormExposure["UNDEFINED_EXPOSURE"] = "UNDEFINED_EXPOSURE";
    /** Form in the editor */
    FormExposure["SITE"] = "SITE";
    FormExposure["STANDALONE"] = "STANDALONE";
})(FormExposure || (FormExposure = {}));
export var EmptyState;
(function (EmptyState) {
    EmptyState["UNDEFINED"] = "UNDEFINED";
    EmptyState["EMAILS"] = "EMAILS";
    EmptyState["USERS"] = "USERS";
})(EmptyState || (EmptyState = {}));
export var SubscriptionSubscriptionMode;
(function (SubscriptionSubscriptionMode) {
    SubscriptionSubscriptionMode["UNDEFINED"] = "UNDEFINED";
    /** User is added to the subscription list directly after filling out the form */
    SubscriptionSubscriptionMode["ON_SUBMIT"] = "ON_SUBMIT";
    /** User is added to the subscription list after they verify their mail address */
    SubscriptionSubscriptionMode["AFTER_CONFIRMATION"] = "AFTER_CONFIRMATION";
})(SubscriptionSubscriptionMode || (SubscriptionSubscriptionMode = {}));
export var SubmissionLimitTimeFrame;
(function (SubmissionLimitTimeFrame) {
    SubmissionLimitTimeFrame["UNDEFINED"] = "UNDEFINED";
    SubmissionLimitTimeFrame["HOURLY"] = "HOURLY";
    SubmissionLimitTimeFrame["DAILY"] = "DAILY";
    SubmissionLimitTimeFrame["WEEKLY"] = "WEEKLY";
    SubmissionLimitTimeFrame["MONTHLY"] = "MONTHLY";
    SubmissionLimitTimeFrame["YEARLY"] = "YEARLY";
    /** No time restriction */
    SubmissionLimitTimeFrame["TOTAL"] = "TOTAL";
})(SubmissionLimitTimeFrame || (SubmissionLimitTimeFrame = {}));
export var DateLimitDateOperator;
(function (DateLimitDateOperator) {
    DateLimitDateOperator["UNDEFINED"] = "UNDEFINED";
    /** Submissions can be done before the specified date */
    DateLimitDateOperator["BEFORE"] = "BEFORE";
})(DateLimitDateOperator || (DateLimitDateOperator = {}));
export var FormStatus;
(function (FormStatus) {
    FormStatus["UNDEFINED_FORM_STATUS"] = "UNDEFINED_FORM_STATUS";
    /** Form is publicly available. */
    FormStatus["PUBLISHED"] = "PUBLISHED";
    /** Form was deleted. */
    FormStatus["DELETED"] = "DELETED";
    /** Form is not yet publicly available. */
    FormStatus["DRAFT"] = "DRAFT";
    /** Form marked as archived. */
    FormStatus["ARCHIVED"] = "ARCHIVED";
})(FormStatus || (FormStatus = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.impl.js.map